import { useId } from 'react'

/**
 * A labelled input with its hint and error wired to it by id.
 *
 * `aria-describedby` and `aria-invalid` are set here rather than at each call
 * site so a screen reader hears the error on every form in the app, not on the
 * forms someone remembered (DESIGN.md, "Accessibility baseline").
 */
export default function Field({
  label,
  hint,
  error,
  type = 'text',
  className = '',
  inputClassName = '',
  ...inputProps
}) {
  const id = useId()
  const hintId = hint ? `${id}-hint` : undefined
  const errorId = error ? `${id}-error` : undefined
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined

  return (
    <div className={`field ${className}`.trim()}>
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        type={type}
        className={`field-input ${inputClassName}`.trim()}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={describedBy}
        {...inputProps}
      />
      {hint ? (
        <p className="field-hint" id={hintId}>
          {hint}
        </p>
      ) : null}
      {error ? (
        <p className="field-error" id={errorId}>
          {error}
        </p>
      ) : null}
    </div>
  )
}
